import { render } from "./KSGroupTableActions.vue?vue&type=template&id=c23424f8"
import script from "./KSGroupTableActions.vue?vue&type=script&lang=js"
export * from "./KSGroupTableActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__